import $ from 'jquery';

class AdditionalEventsSelector {
  constructor() {
    const $select = $('#tn-additional-events-select');
    const $btn = $('#tn-additional-events-btn-submit');

    $select.on('change', () => {
      const hasSelection = $select.val() !== '';
      $btn.prop('disabled', hasSelection === false);
    });

    $btn.on('click', () => {
      window.location.href = $select.val();
    });
  }
}

export default AdditionalEventsSelector;



// WEBPACK FOOTER //
// ./V7/events/detail/AdditionalEventsSelector.js